// src/lib/dateUtils.ts

/**
 * Format a date string as '12-May-2025'.
 */
export function formatEntryDate(dateStr: string) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).replace(/ /g, '-');
}

/**
 * Format a YYYY-MM string as 'May 2025'.
 */
export function formatMonthCard(monthStr: string) {
  const [year, month] = monthStr.split('-');
  const d = new Date(Number(year), Number(month) - 1);
  return d.toLocaleString('en-GB', { month: 'short', year: 'numeric' });
}

/**
 * Get today's date in YYYY-MM-DD format (for default form values).
 */
export function getTodayISO() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Get today's date in '12-May-2025' format (for display).
 */
export function getTodayFormatted() {
  return formatEntryDate(new Date().toISOString());
}

export function getTodayDisplay() {
  const today = new Date();
  return today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).replace(/ /g, '-');
} 